module.exports = require("@mui/material/Collapse");